import { useState, useEffect } from "react";
import { Grid, Button, FormControl, Select, MenuItem } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactComponent as PrinterIcon } from "../../../images/svg/printer-grey.svg";
import styles from "./styles.module.css";
import { INVOICE_PRINTER, INVOICE_FORMATS } from "const";
import toast from "react-hot-toast";
import { ReactComponent as FormatIcon } from "../../../images/svg/document.svg";
import * as TerminalHelper from "helpers/TermialHelper";

function KotFormatPage() {
  const [kotFormat, setKotFormat] = useState("");
  const [consolidatedKotFormat, setConsolidatedKotFormat] = useState("");

  useEffect(() => {
    const terminalSettings = TerminalHelper.getTerminalSettings();
    const kotFormat = terminalSettings.kotFormat || INVOICE_FORMATS.THREE_INCH;
    const consolidatedKotFormat = terminalSettings.consolidatedKotFormat || INVOICE_FORMATS.THREE_INCH;

    if (kotFormat) setKotFormat(kotFormat);
    if (consolidatedKotFormat) setConsolidatedKotFormat(consolidatedKotFormat);
  }, []);

  const handleSave = async () => {
    if (!kotFormat || !consolidatedKotFormat) {
      toast.error("Please select both KOT formats");
      return;
    }

    try {
      await TerminalHelper.updateTerminalSettings({
        kotFormat,
        consolidatedKotFormat,
      });
      toast.success("KOT formats saved successfully");
    } catch (error) {
      toast.error("Failed to save KOT formats");
    }
  };

  return (
    <Grid container className={styles.contentWrapper} rowGap={2}>
      <Grid item xs={12} className={styles.titleWrapper}>
        <Grid className={styles.formSection}>
          <PrinterIcon />
          <h3 className={styles.subTitle}>KOT Format :</h3>
          <FormControl variant="standard" className={styles.selectWrapper}>
            <Select
              value={kotFormat}
              onChange={(e) => setKotFormat(e.target.value)}
              displayEmpty
              disableUnderline
              IconComponent={ExpandMoreIcon}
              renderValue={(value) => {
                if (!value) return <span style={{ color: "#aaa" }}>Select KOT Format</span>;
                return <span className={styles.mainTitle}>{value}</span>;
              }}
              sx={{
                "& .MuiSelect-select": { padding: 0 },
                "& .MuiSelect-icon": { color: "#7a7a7a", right: "8px" },
              }}
            >
              <MenuItem disabled value="">
                Select KOT Format
              </MenuItem>
              {INVOICE_PRINTER.kotFomat.map((format, index) => (
                <MenuItem key={index} value={format}>
                  {format}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid item xs={12} className={styles.titleWrapper}>
        <Grid className={styles.formSection}>
          <FormatIcon />
          <h3 className={styles.subTitle}>Consolidate KOT Format :</h3>
          <FormControl variant="standard" className={styles.selectWrapper}>
            <Select
              value={consolidatedKotFormat}
              onChange={(e) => setConsolidatedKotFormat(e.target.value)}
              displayEmpty
              disableUnderline
              IconComponent={ExpandMoreIcon}
              renderValue={(value) => {
                if (!value) return <span style={{ color: "#aaa" }}>Select Consolidate KOT Format</span>;
                return <span className={styles.mainTitle}>{value}</span>;
              }}
              sx={{
                "& .MuiSelect-select": { padding: 0 },
                "& .MuiSelect-icon": { color: "#7a7a7a", right: "8px" },
              }}
            >
              <MenuItem disabled value="">
                Select Consolidate KOT Format
              </MenuItem>
              {INVOICE_PRINTER.kotFomat.map((format, index) => (
                <MenuItem key={index} value={format}>
                  {format}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid item xs={12} display="flex" justifyContent="flex-end" mt={2}>
        <Button className={styles.buttonRed} onClick={handleSave}>
          Save
        </Button>
      </Grid>
    </Grid>
  );
}

export default KotFormatPage;
